import { render, staticRenderFns } from "./autoDeductionOptionSet.vue?vue&type=template&id=0c7a70fb&scoped=true&"
import script from "./autoDeductionOptionSet.vue?vue&type=script&lang=js&"
export * from "./autoDeductionOptionSet.vue?vue&type=script&lang=js&"
import style0 from "./autoDeductionOptionSet.vue?vue&type=style&index=0&id=0c7a70fb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7a70fb",
  null
  
)

export default component.exports